enum ROUTE_ENUM {
  HOME = "/",
  REGISTER = "/register",
  LOGIN = "/login",
  LOGIN_ADMIN = "/login-admin",
  ENTER_CODE = "/enter-code",
  REGISTER_ADMIN = "/register-admin",
  LINK_EXPIRED = "/link-expired",
  RESET_PASSWORD = "/reset-password",
  CREATE_NEW_PASSWORD = "/create-new-password",
  DASHBOARD= "/dashboard",
  USERS = "/dashboard/users",
  COMPANIES = "/dashboard/companies",
  PAYMENTS = "/dashboard/payments",
  MARKET_INFORMATION = "/dashboard/market-information",
  ANALYSIS = "/dashboard/analysis",
  PROFILE = "/dashboard/profile",
  CONTACT = "/dashboard/contact",
  INVESTMENTS = "/dashboard/investments",
  SVG_TEST = "/svg-test",
  POST = "/dashboard/post/:id",
  RODO = "/rodo",
  PRIVACY_POLICY = "/privacy-policy",
  TERMS_OF_SERVICE = "/terms-of-service",
  SUCCESSOR = "/dashboard/successor",
  SUCCESSOR_RESET_PASSWORD = "/dashboard/successor-reset-password",
}

export default ROUTE_ENUM;
